// extracted by mini-css-extract-plugin
module.exports = {"section":"AboutHero_section__02mMg","shape":"AboutHero_shape__mF3zE","textSection":"AboutHero_textSection__3hS_N","description":"AboutHero_description__IAPqQ"};